// extracted by mini-css-extract-plugin
export var headerSection = "SuccessStoriesV3-module--headerSection--Oe2mw";
export var mainTitle = "SuccessStoriesV3-module--mainTitle--AW7v4";
export var playButton = "SuccessStoriesV3-module--playButton--VAgro";
export var playButtonOverlay = "SuccessStoriesV3-module--playButtonOverlay--31W9t";
export var subTitle = "SuccessStoriesV3-module--subTitle--wO7gu";
export var successStoriesWrapper = "SuccessStoriesV3-module--successStoriesWrapper--3Z3PO";
export var videoCard = "SuccessStoriesV3-module--videoCard--ICGBN";
export var videoDescription = "SuccessStoriesV3-module--videoDescription--dc-O-";
export var videoImage = "SuccessStoriesV3-module--videoImage--tg+1V";
export var videoImageWrapper = "SuccessStoriesV3-module--videoImageWrapper--Nj6Y+";
export var videoInfo = "SuccessStoriesV3-module--videoInfo--AHQw-";
export var videoTitle = "SuccessStoriesV3-module--videoTitle--AD2eK";